var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode!='')?_c('v-container',{staticClass:"form-container"},[_c('g-form',{attrs:{"controller":"workflow","title":_vm.controller.currentSystemModule.name+' '+_vm.mode,"mode":_vm.mode}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }